import { useEffect } from 'react';

import TVEvents from '../utils/TVEvents';

export function useKeyHandler(keys: string[], cb: (key: string) => void) {
	useEffect(() => {
		const listener = TVEvents.addEventListener((eventType) => {
			if (keys.includes(eventType)) {
				return cb(eventType);
			}
		});
		return listener.remove;
	}, [cb, keys]);
}
